﻿
import counterUp from 'counterup2'

var numberSpin = (function () {
    var cnts;

    var animateOnVisible = function () {
        cnts = [].slice.call(document.querySelectorAll("[data-counter]"));
        console.log("number spin", cnts);
        if ("IntersectionObserver" in window) {
            let cntObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        //console.log("Intersecting", entry);
                        counterUp(entry.target, {
                            duration: 1000,
                            delay: 16,
                        });
                        cntObserver.unobserve(entry.target);
                    }
                });
            });
            cnts.forEach(function (cnt) {
                cntObserver.observe(cnt);
            });
        } else {
            //fall back - no animations!
        }
    }

    return {
        init: function () {
            console.log("Called numberspin!");
            animateOnVisible();
        }
    };
})();



window.countUp = function () {
    console.log("called count up");
    const el = document.querySelector('.counter');
    // Start counting, do this on DOM ready or with Waypoints.
    counterUp(el, {
        duration: 20000,
        delay: 250,
    });
}



window.numberSpin = function () {

    const counters = document.querySelectorAll('.spin-up');
    // const speed = 200;

    const bindpop = (target) => {
        const io = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {

                    // add a small deley, then animate
                    setTimeout(function () {
                        animate(entry.target);
                        observer.disconnect();
                    }, 300);                    
                }
            })
        }, { threshold: [1] });

        io.observe(target);
    }

    counters.forEach(bindpop);






    function animate(el) {

        const value = parseFloat(el.getAttribute('data-value-to'));
        var speed = el.getAttribute('data-speed');
        var increment = parseFloat(el.getAttribute('data-increment'));
        var data = parseFloat(el.innerText);

        if (speed == '')
            speed = 200;

        if (increment == null || increment == '')
            increment = 1;

        if (data < value) {

            // this is where the new value is calculated - it could be much improved!!
            // var newVal = Math.ceil(data + increment);
            var newVal = data + increment;

            // whole number or (assuming single) decimal point
            // todo : determine the number of decimal points
            // todo : deal with formatted thousands seperators
            if (isFloat(data))
                el.innerText = newVal.toFixed(1);
            else
                el.innerText = newVal.toFixed(0);

            setTimeout(function () {
                animate(el);
            }, speed);

        } else {
            el.innerText = value;
        }
    }

    function isFloat(n) {
        return Number(n) === n && n % 1 !== 0;
    }
}


if (document.readyState !== 'loading') {
    window.numberSpin();
    console.log("called count up 1");
    numberSpin.init();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        window.numberSpin();
        //window.countUp();
        console.log("called count up 2");
        numberSpin.init();
    });
};